import React, { useEffect, useState, lazy, Suspense } from "react";
import './css/Searchbar.css';
import { getZipCode, getAllPackage, getSearchForChannel, getCompareChannel } from './actions/action'
import { connect } from "react-redux";
import { isMobile } from './utils/generic'
import Allpackage from "./Allpackage";
//import images from './images/loading-large.png';
//import images from './images/10_1.jpg';
import { Input } from '@vds/inputs';
//import Image from './ImageComponent';
const Image = lazy(() => import('./ImageComponent'));
import LoaderSpinner from './LoaderSpinner';

function SearchBox(props) {
    const [zipcode, setZipcode] = useState("");
    const [error, setError] = useState(false);
    const [region, setRegion] = useState([]);
    const [active, setActive] = useState(false);
    const [packageText, setPackageText] = useState(true);
    const [showPackage, setShowPackage] = useState(false);
    const [inputEnable, setInputEnable] = useState(true);
    const [searchShow, setSearchShow] = useState([]);
    const [ifa, setIfa] = useState('');
    const [channelCompare, setChannelCompare] = useState(false);
    const [searchChannelCount, setSearchChannelCount] = useState(0);
    const [searchLimit, setSearchLimit] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [compareData, setCompareData] = useState([]);
    const [noChannelFound, setNoChannelFound] = useState(false)
    const platform = isMobile();
    const [channelNotAvailable, setChannelNotAvailable] = useState(false);
    const [viewCompareChannel, setViewCompareChannel] = useState(false);
    const queryUrl = window.location.href;
    const searchValue = queryUrl?.split('?')[1];
    const searchParam = new URLSearchParams(searchValue);
    const appId = searchParam.get('appid') || 'consumer';
    const [clearChannel, setClearChannel] = useState(false);
    const [cursor, setCursor] = useState(0);
    useEffect(() => {
        const feZip = window.sessionStorage.getItem("fezip") || '';
        const ifaRegion = window.sessionStorage.getItem("lfaregion") || '';
        let enterZipcode;
        if (feZip != '') {
            enterZipcode = JSON.parse(window.sessionStorage.getItem(`consumer${feZip}`)) || '';
            // console.log("enterZipcode", enterZipcode);
        }
        if (enterZipcode) {
            setActive(true);
            setIfa(ifaRegion);
            setRegion([]);
            setZipcode(ifaRegion);
            let searchedList = JSON.parse(window.sessionStorage.getItem("searchedArray")) || '';
            if (searchedList.length > 0) {
                setChannelCompare(true);
                setCompareData(searchedList);
            }
            setShowPackage(true);
            setInputEnable(false);
        }
    }, [])

    const placeholderChange = (e) => {
        //console.log("focus method working", e.target.value);
        if (e.target.value != '') {
            const selectedZip = window.sessionStorage.getItem("fezip") || '';
            let findZipcode;
            if (selectedZip != '') {
                findZipcode = JSON.parse(window.sessionStorage.getItem(`consumer${selectedZip}`)) || props?.zipcodeData;
            }
            if (findZipcode?.vhoregionlist?.length > 0) {
                const selectedRegion = findZipcode?.vhoregionlist.filter((item) => {
                    return item.lfa == e.target.value
                });
                //console.log("selectedRegion", selectedRegion, e.target.value);
                if (selectedRegion.length == 1) {
                    setZipcode(selectedRegion[0].zip);
                }
            }

        }
    }

    const inputHandler = (e) => {
        const reg = /^[0-9\b]+$/;
        if (e.target.value === '' || reg.test(e.target.value)) {
            if (e.target.value.length === 5) {
                window.sessionStorage.setItem("fezip", e.target.value);
                const enteredZipcode = JSON.parse(window.sessionStorage.getItem(`consumer${e.target.value}`)) || '';
                if (enteredZipcode == '') {
                    let appid = appId
                    let tarcode = ""
                    let visitid = (window.localStorage.getItem("visit_id") || '')
                    let visitorid = (window.localStorage.getItem("visitor_id") || '')
                    let zip = e.target.value
                    getZipCode(props.dispatch, visitid, visitorid, tarcode, zip, appid);
                }
            }
            setZipcode(e.target.value);
            fetchRegionData(e.target.value);
            setChannelCompare(false);
            setSearchChannelCount(0);
            setCompareData([])
            window.sessionStorage.setItem("searchedArray", JSON.stringify([]));
        }
    }

    const showDropdown = (e) => {
        if (e.key === 'Enter') {
            if (e.target.value.length == 5) {
                if (props?.zipcodeData?.vhoregionlist?.length > 0) {
                    setRegion(props.zipcodeData.vhoregionlist)
                    setZipcode(e.target.value)
                }
            }
        }
    }
    useEffect(() => {
        const feZip = window.sessionStorage.getItem("fezip") || '';
        if (props?.zipcodeData?.vhoregionlist?.length > 0) {
            const zipValue = window.sessionStorage.getItem(`consumer${feZip}`) || '';
            //console.log("zipValue",zipValue,feZip);
            if ((zipValue == '') && (feZip != '')) {
                window.sessionStorage.setItem(`consumer${zipcode}`, JSON.stringify(props?.zipcodeData));
                setRegion(props?.zipcodeData?.vhoregionlist)
                setError(false);
            }
        } if (props?.zipcodeData?.vhoregionlist?.length == 0) {
            if (feZip != '') {
                window.sessionStorage.setItem(`consumer${zipcode}`, JSON.stringify(props?.zipcodeData));
                setError(true)
                setRegion([])
            }
        }
    }, [props?.zipcodeData])

    //code for fetching regions from particular zipcode
    function fetchRegionData(zipcode) {
        if (zipcode.length === 5) {
            const zipValue = JSON.parse(window.sessionStorage.getItem(`consumer${zipcode}`)) || '';
            //console.log("zipValue",zipValue, zipcode);
            if (zipValue != '') {
                //window.sessionStorage.setItem(`consumer${zipcode}`,JSON.stringify(props?.zipcodeData));
                if (zipValue?.vhoregionlist.length > 0) {
                    setRegion(zipValue?.vhoregionlist)
                    setError(false)
                } else {
                    setError(true)
                    setRegion([])
                }
            } 
            // if (zipValue === '') {
            //     setError(true)
            //     setRegion([])
            // }
        } if (zipcode.length < 5) {
            setRegion([]);
            setShowPackage(false);
            setError(false);
            setInputEnable(true);
            window.sessionStorage.removeItem('PackageSelected')
        }
    }

    //code for removing border from  searchcontainer
    function showPackages(lfaregion, vhoname) {
        const payload = {
            appid: appId,
            csrpackage: "",
            lfa: lfaregion,
            vhoname: vhoname,
            visitid: (window.localStorage.getItem("visit_id") || ''),
            visitorid: (window.localStorage.getItem("visitor_id") || '')
        }
        window.sessionStorage.setItem("lfaregion", lfaregion);
        window.sessionStorage.setItem("vhoname", vhoname);
        const fezip = window.sessionStorage.getItem("fezip") || '';
        const regionSelected = JSON.parse(window.sessionStorage.getItem(`consumer${fezip}${lfaregion}`)) || '';
        if (regionSelected == '') {
            getAllPackage(props.dispatch, payload);
        }
        setActive(true);
        setIfa(lfaregion);
        setRegion([]);
        setZipcode(lfaregion);
        setShowPackage(true);
        setInputEnable(false);
    }

    const searchHandler = (e) => {
        if (e.target.value != '') {
            setSearchText(e.target.value);
            setChannelNotAvailable(false)
            const payload = {
                appid: appId,
                lfa: ifa,
                programchannelname: e.target.value,
                visitid: (window.localStorage.getItem("visit_id") || ''),
                visitorid: (window.localStorage.getItem("visitor_id") || '')
            }
            getSearchForChannel(props.dispatch, payload);
        } else {
            setSearchShow([]);
            setSearchText('');
            setChannelNotAvailable(false)
        }
    }

    useEffect(() => {
        if (searchText != '') {
            setSearchShow(props?.searchChannelData?.chanelprogramlist);
            setChannelNotAvailable(false)
            if(props?.searchChannelData?.chanelprogramlist?.length < 1){
                setChannelNotAvailable(true)
            }
        }
    }, [searchText, props?.searchChannelData])

    if (document.getElementById('search_list') != null) {
        document.addEventListener('click', (e) => {
            if (e.target != "img" && e.target != "li" && e.target != "a") {
                //console.log("display ", e)
                setSearchShow([]);
            }
        })
    }
    const searchListHandler = (element) => {
        //console.log("pac selected", element);
        if (element != '') {
            setSearchShow([]);
            setSearchText('');
            const maxSearchLimit = platform ? 2 : 4;
            if (searchLimit < maxSearchLimit) {
                setSearchChannelCount(searchChannelCount + 1);
                const payload = {
                    appid: appId,
                    channelid: element.channelid,
                    elkchannelprogram: element.elkchannelname,
                    lfa: ifa,
                    name: element.name,
                    programid: element.programid,
                    type: element.type,
                    vhoname: (window.sessionStorage.getItem("vhoname") || "BURLINGTON MA"),
                    visitid: (window.localStorage.getItem("visit_id") || ''),
                    visitorid: (window.localStorage.getItem("visitor_id") || '')
                }
                getCompareChannel(props.dispatch, payload);
                setChannelCompare(true);
            }
        }
    }
    useEffect(() => {
        if (searchChannelCount > 0) {
            if (props?.compareChannelData?.channellistwithpack?.length > 0) {
                const newObj = { ...props?.compareChannelData?.channellistwithpack[0], count: searchChannelCount }
                setCompareData(compareData => [...compareData, newObj]);
                setNoChannelFound(false)
            } else {
                setNoChannelFound(true)
            }
        }
    }, [props?.compareChannelData])
    function serachedChannelCount(count) {
        setSearchLimit(count.length);
        setCompareData(count);
        if(!platform){
            if(count.length === 4){
                setClearChannel(true);
            }
            else{
                setClearChannel(false);
            }
        }
        if(platform){
            if(count.length === 2){
                setClearChannel(true);
            }else{
                setClearChannel(false);
            }
        }
        //console.log("compareData1 search",compareData);
        //console.log("serachedChannelCount",searchLimit, count);
    }
    const clearCompare = () => {
        setChannelCompare(false);
        setSearchLimit(0);
        setSearchChannelCount(0);
        setCompareData([]);
        setClearChannel(false);
        window.sessionStorage.setItem("searchedArray", JSON.stringify([]));
    }
    //function to check whether image exist in folder or not
    // function CheckImage(path) {
    //     try {
    //         let urlImg = <LazyLoadImage>{require(`./images/${path}`).default}</LazyLoadImage>
    //         // console.log("imgurl",urlImg)
    //         return true;
    //     }
    //     catch (error) {
    //         return false;
    //     }
    // }

    const compareChannelClicked = (opened) =>{
        setViewCompareChannel(opened)
        props.viewcompareContent(opened)
    }

    const LoadImage = (element) =>{
        const images = <Image element={element.logourl}/>
        return images;
    }
    function dropdownHandler(e) {
        if (e.target.value != '') {
          if (e.keyCode === 38 && cursor > 0) {
            console.log('up key pressed');
            setCursor((prev)=>prev -1);
            let element=document.getElementById("search_list")
            element.scrollTop-=50
            //element.scrollBottom+=10
          }
          if (e.keyCode === 40 && cursor < searchShow?.length-1) {
            console.log('down key is pressed');
            setCursor((prev)=>prev+1);
            let element=document.getElementById("search_list")
            element.scrollTop+=50
          }
        }
    }
    return (
        <div>
            <>
            {!viewCompareChannel &&
            <div className="searchBoxContainer">
                <div className={active ? "searchContainer showBorder" : "searchContainer"}>
                    <div className="addressInput">
                    <Input
                        type="text"
                        label={platform ? 'zip code' :' Enter zip code'}
                        name="zipcode" id="zipcode"
                        maxLength="5"
                        disabled={false}
                        required={false}
                        value={zipcode}
                        onChange={inputHandler}
                        onFocus={placeholderChange}
                        onKeyDown={showDropdown}
                        data-testid="Enter zip code"/>
                    </div>
                    <div className="searchListContainer">
                        <Input
                            type="text"
                            label={platform ? "Search upto 2 channels or shows" : "Search upto 4 channels or shows"}
                            name="channel" id="channelText"
                            className="addressInput2"
                            value={searchText}
                            required={false}
                            error={false}
                            disabled={inputEnable}
                            onChange={searchHandler}
                            data-testid="Search upto 4 channels or shows"
                            onKeyDown={dropdownHandler}
                        />
                        {
                            searchShow?.length > 0 &&
                            <div className="searchList">
                                <ul className="search-list" id="search_list">
                                    {searchShow.map((element, index) => {
                                        return (
                                            <li onClick={() => searchListHandler(element)} key={index} ><a className={cursor === index ? 'activeItem' : null}>
                                                {/* <img  src={element.logourl  ? `https://www.verizon.com/content/dam/verizon/personal/cluimages/${element.logourl}` : 'https://www.verizon.com/content/dam/verizon/personal/atom/loading-large.png'} /> */}
                                                {/* <img className="tableImage" src={require( `./images/${element.logourl}`).default } alt="unable to display"/> */}
                                                {/* <LazyLoadImage>
                                                <img alt='image' fetchPriority='low' decoding='async' role="presentation" className="searchedImage" loading="lazy" src={CheckImage(element.logourl) ? require(`./images/${element.logourl}`).default : images} />
                                                </LazyLoadImage> */}
                                                {/*LoadImage(element)*/}
                                                <Suspense fallback={<LoaderSpinner/>}>
                                                {<Image element={element.logourl}/>}
                                                </Suspense>
                                                <span className="searchedChannelName">{element.name}</span></a></li>
                                        )
                                    })
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                </div>
                <div style={{ display: "flex" }}>
                    <div className="regionlist">
                        {
                            //code for showing regions in particular zipcode
                            region.length > 0 &&
                            <ul className="region-list">
                                {region.map((element, index) => {
                                    return (
                                        <li key={index} onClick={() => showPackages(element.lfa, element.vhoname)}><a data-testid={`Regions${element.lfa}`} onClick={() => showPackages(element.lfa, element.vhoname)}>
                                            {element.lfaname}</a>
                                        </li>
                                    )
                                })
                                }
                            </ul>
                        }
                    </div>

                </div>
                <div className="error-container">
                    {
                        <h6 className="error-txt">Packages available in your area</h6>
                    }
                    {
                        error ? (<h6 className="error-txtmsg">We don't have service in the selected area.</h6>) : null
                    }
                    {clearChannel &&
                        <h6 data-testid="clearFunc" onClick={clearCompare} className="clearSelection"> Clear selection(s) to search again</h6>
                    }
                    {noChannelFound &&
                        <h6 className="error-txtmsg">Channel/Program not available. Please search different channel/program</h6>
                    }
                    {channelNotAvailable &&
                        <h6 className="error-txtmsg">Sorry, channel or program you searched for is not available.</h6>
                    }
                </div>
            </div>
            }
            {showPackage &&
                <div>
                    <Allpackage channelCompare={channelCompare}
                        searchChannelCount={searchChannelCount} serachedChannelCount={serachedChannelCount} compareData={compareData}
                        ifa={ifa} compareChannelClicked={compareChannelClicked}/>
                </div>
            }
            </>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        zipcodeData: state.channelReducer.zipcodeData,
        searchChannelData: state.channelReducer.searchChannelData,
        compareChannelData: state.channelReducer.compareChannelData
    }
}

export default React.memo(connect(mapStateToProps)(SearchBox));